import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { ClipboardList, ArrowRight } from "lucide-react";

const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem('authToken')}` });

export const ActivitySubmissionsSummary = () => {
  const [items, setItems] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetch('/api/activities/teacher/summary', { headers: authHeaders() })
      .then(r => (r.ok ? r.json() : { items: [] }))
      .then(d => setItems(d.items || []))
      .catch(() => setItems([]));
  }, []);

  if (items.length === 0) return null;
  const pending = items.reduce((n, i) => n + i.pending, 0);

  return (
    <Card className="border-violet-200 bg-violet-50/40" data-testid="activity-submissions-summary">
      <CardHeader className="pb-2">
        <CardTitle className="text-base flex items-center gap-2">
          <ClipboardList className="h-4 w-4 text-violet-600" /> Activities & Chapter Tests
          {pending > 0 && <Badge className="bg-yellow-100 text-yellow-800" data-testid="activity-pending-count">{pending} need marking</Badge>}
        </CardTitle>
        <p className="text-xs text-slate-500">Answers from the Activity Booklet are marked on the Activities page — click an item to open it.</p>
      </CardHeader>
      <CardContent className="grid gap-2 sm:grid-cols-2 lg:grid-cols-3">
        {items.map(it => (
          <button key={it.item_id} onClick={() => navigate(`/dashboard/activities?subject=${encodeURIComponent(it.subject)}&year=${it.year_level}&item=${it.item_id}`)}
            className="text-left rounded-lg border bg-white p-3 hover:border-violet-400 transition-colors" data-testid={`activity-summary-${it.item_id}`}>
            <div className="text-xs text-slate-500">Year {it.year_level} {it.subject} · {it.code}</div>
            <div className="font-medium text-slate-900 text-sm truncate">{it.title}</div>
            <div className="flex items-center justify-between mt-1 text-xs">
              <span className={it.pending > 0 ? "text-yellow-700 font-medium" : "text-slate-500"}>{it.pending} to mark · {it.marked} marked</span>
              <ArrowRight className="h-3.5 w-3.5 text-slate-400" />
            </div>
          </button>
        ))}
        <Button variant="link" className="justify-start px-0 text-violet-700" onClick={() => navigate('/dashboard/activities')} data-testid="activity-summary-open-page">Open Activities page</Button>
      </CardContent>
    </Card>
  );
};
